export default "__VITE_ASSET__CzfmpT7e__"